import React from 'react';
import { Button, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { ApplicationIcons } from 'icons/ApplicationIcons';
import { useActiveCart } from 'services/Data/CartService';
import useMobile from 'services/Hooks/useMobile';
import { useSelector } from 'react-redux';
import { useActiveMerchandisingProgramQuote } from 'services/Data/MerchandisingProgramQuoteService';
import { useActiveExteriorSignageQuote } from 'services/Data/ExteriorSignageQuoteService';
import { IsImpersonationMode } from 'config/config';

const CartButton = () => {
  const accountReducer = useSelector(state => state.AccountReducer);

  const { t } = useTranslation();
  const dealerId = accountReducer?.profile?.dealer_Id;
  const { data: cart } = useActiveCart(accountReducer.isLoggedIn, false, IsImpersonationMode ? dealerId : null);
  const { data: merchandisingProgramQuote } = useActiveMerchandisingProgramQuote(accountReducer.isLoggedIn);
  const { data: exteriorSignageQuote } = useActiveExteriorSignageQuote(accountReducer.isLoggedIn);

  const isMobile = useMobile();

  return (
    <React.Fragment>
      <Button
        style={{ boxShadow: 'none' }}
        variant="contained"
        endIcon={<ApplicationIcons.Cart />}
        component={NavLink}
        to={'/dealer/cart'}>
        <Typography variant="h4">
          {' '}
          {isMobile ? '' : t('cart')} (
          {(cart?.cartItems?.length ?? 0) +
            (cart?.cartWalls?.length ?? 0) +
            (cart?.cartToolings?.length ?? 0) +
            (merchandisingProgramQuote?.quoteItems?.length ?? 0) +
            (exteriorSignageQuote?.quoteItems?.length ?? 0)}
          )
        </Typography>
      </Button>
    </React.Fragment>
  );
};

export default CartButton;
